// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CreateTenancyInviteDetailsDTO } from './create-tenancy-invite-details-dto';

/**
 * 
 * @export
 * @interface CreateTenancyInviteDTO
 */
export interface CreateTenancyInviteDTO {
    /**
     * 
     * @type {CreateTenancyInviteDetailsDTO}
     * @memberof CreateTenancyInviteDTO
     */
    details?: CreateTenancyInviteDetailsDTO;
    /**
     * 
     * @type {string}
     * @memberof CreateTenancyInviteDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTenancyInviteDTO
     */
    roleId: CreateTenancyInviteDTORoleIdEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateTenancyInviteDTORoleIdEnum {
    TENANT = 'TENANT'
}



